import {Box, Flex} from "@chakra-ui/react";
import {InputLabel, StyledButton} from "../../index";
import {ReactComponent as EmailIcon} from "../../../assets/icons/emailIcon.svg";

export const ForgetPasswordForm = ({isMobile, handleSubmit, submit, errors, register, isValid, isDirty}) => (
    <form onSubmit={handleSubmit(submit)}>
        <Flex
            position={'relative'}
            direction={'column'}
            alignItems={'center'}
            gap={isMobile ? '32px' : '48px'}>
            <InputLabel
                label={'Email'}
                height={isMobile ? '40px' : '56px'}
                fontSize={isMobile ? '14px' : '18px'}
                isInvalid={!!errors.email}
                {...register('email', {
                    required: 'Email is required',
                    pattern: {
                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Invalid email address",
                    },
                })}
                placeholder={'Email or Phone number'}
                maxW={'565px'}
                leftAddon={<EmailIcon width={isMobile ? '20px' : '25px'}/>}
            />
            <StyledButton
                disabled={!(isValid && isDirty)}
                height={isMobile ? '40px' : '56px'}
                type={'submit'}
                fontSize={'body.lg'}
                maxW={'565px'}
                width={'full'}>
                Get verification code
            </StyledButton>
            <Box
                position={'absolute'}
                left={'50%'}
                transform="translate(-50%, -20%)"
                zIndex={'1'}
                w={'78px'}
                h={'38px'}
                border={'1px solid'}
                borderColor={'neutral.800'}
                borderRadius={'8px'}/>
        </Flex>
    </form>
)
